export default __webpack_public_path__ + "static/media/intro.153e0554.jpg";